import React, { useEffect, useReducer, useState } from "react";
import Logo from "../../assets/logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { Search, Heart } from "lucide-react";
import { LOGGED_IN_USER_UPDATED } from "../../constants/sessionEvents";
import NotificationsPanel from "./NotificationsPanel";
import StudentMobileProfileSidebar from "./StudentMobileProfileSidebar";
import { Bell } from "./StudentModuleIcons";

const DEFAULT_PROFILE_IMAGE =
  "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=200&q=80";

const StudentNavbar = () => {
  const navigate = useNavigate();
  const [, refresh] = useReducer((n) => n + 1, 0);

  useEffect(() => {
    const onUserUpdated = () => refresh();
    window.addEventListener(LOGGED_IN_USER_UPDATED, onUserUpdated);
    return () =>
      window.removeEventListener(LOGGED_IN_USER_UPDATED, onUserUpdated);
  }, []);

  const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showMobileProfile, setShowMobileProfile] = useState(false);
  return (
    <div className="bg-[#F5F5F5] border-b border-[#938A9636]">
      <div className="mx-auto flex w-full max-w-[1920px] items-center justify-between gap-4 px-3 py-2 sm:gap-6 sm:px-6 lg:gap-10 lg:pl-11 lg:pr-20 lg:py-3 min-[1920px]:gap-14">
        <Link to="/student" className="flex shrink-0 items-center gap-1 lg:gap-3">
          <img
            src={Logo}
            alt="STEAM Minds"
            className="w-10 lg:w-12 h-16 lg:h-[72px]"
          />
          <h1 className="font-semibold hidden sm:block text-lg lg:text-xl tracking-[4%] lg:tracking-[6%] text-[#4A4A68] whitespace-nowrap max-w-[266px]">
            STEAM Minds
          </h1>
        </Link>

        <div className="flex min-w-0 flex-1 items-center justify-end gap-3 sm:justify-between sm:gap-6 lg:max-w-[695px] lg:gap-10">
          <div className="hidden min-w-0 max-w-[424px] flex-1 sm:block">
            <div className="flex items-center border border-[#E9EAF0] bg-white px-3 py-1.5 lg:px-5 lg:py-[11px]">
              <Search size={16} className="text-[#1D2026]" />
              <input
                type="text"
                placeholder="What do you want learn..."
                className="flex-1 ml-3 outline-none font-['Inter'] text-sm lg:text-base text-gray-700 placeholder:text-[#8C94A3]"
              />
            </div>
            <div className="relative flex justify-end sm:hidden">
              <button
                onClick={() => setShowMobileSearch(!showMobileSearch)}
                className="p-1 hover:bg-white rounded-full transition"
              >
                <Search size={18} className="text-[#1D2026]" />
              </button>

              {showMobileSearch && (
                <div className="absolute top-8 right-0 w-[270px] bg-white border border-[#E9EAF0] rounded-md shadow-lg px-3 py-2 flex items-center z-50">
                  <Search size={16} className="text-[#1D2026]" />

                  <input
                    type="text"
                    autoFocus
                    placeholder="Search..."
                    className="flex-1 ml-2 outline-none text-sm text-gray-700 placeholder:text-[#8C94A3]"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="flex items-center gap-3 lg:gap-6">
            <button
              type="button"
              onClick={() => setShowNotifications(true)}
              className="relative hover:bg-white rounded-full transition"
            >
              <Bell />
              <span className="absolute top-px right-1 h-2 w-2 rounded-full bg-[#FF6636] border border-white"></span>
            </button>
            <button
              onClick={() => navigate("/student/wishlist")}
              className=" hover:bg-white rounded-full transition"
            >
              <Heart size={24} className="text-[#1D2026]" />
            </button>
            {/* <button
              className="relative p-2 hover:bg-white rounded-full transition"
              onClick={() => navigate("/student/wishlist")}
            >
              <Cart size={24} className="text-[#1D2026]" />
              {cartCount > 0 && (
                <span className="absolute top-0.5 -right-1 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-[#FF6636] px-1.5 text-[10px] font-semibold text-white">
                  {cartCount}
                </span>
              )}
            </button> */}

            {/* Profile Avatar */}
            <button
              type="button"
              onClick={() => setShowMobileProfile(true)}
              className="h-9 w-9 overflow-hidden rounded-full bg-[#FF6636] sm:pointer-events-none lg:h-12 lg:w-12"
              aria-label="Open profile menu"
            >
              <img
                src={loggedInUser?.profilePicture || DEFAULT_PROFILE_IMAGE}
                alt="profile"
                className="h-full w-full object-cover"
              />
            </button>
          </div>
        </div>
      </div>

      <NotificationsPanel
        open={showNotifications}
        onClose={() => setShowNotifications(false)}
      />

      <StudentMobileProfileSidebar
        open={showMobileProfile}
        onClose={() => setShowMobileProfile(false)}
        loggedInUser={loggedInUser}
      />
    </div>
  );
};

export default StudentNavbar;
